import { EsignSignatureType } from "@/types/esign.types.ts";
import {
  Avatar,
  Button,
  Modal,
  ModalProps,
  Stack,
  Text,
  Title,
  useModals,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface EsignRequestSentModalProps extends ModalProps {
  signatureType: EsignSignatureType;
  recipientCount: number;
}

export function EsignRequestSentModal({
  signatureType,
  recipientCount,
  ...props
}: EsignRequestSentModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const { id } = props;

  const isAcknowledge = signatureType === EsignSignatureType.acknowledge;

  return (
    <Modal
      {...props}
      title={t(
        isAcknowledge ? "core:esign_request_acknowledgment" : "core:esign_request_signatures"
      )}
      variant={"middle"}
      size={"md"}
      withCloser={true}
      actions={
        <Button className={"w-full"} variant={"plain"} size={"md"} onClick={() => close(id)}>
          {t("common:close")}
        </Button>
      }
    >
      <Stack items={"center"} className={"gap-3 py-4 text-center"}>
        <Avatar emoji={":incoming_envelope:"} size={"xl"} />
        <Stack items={"center"} className={"gap-1"}>
          <Title
            size={"lg"}
            header={t(
              isAcknowledge
                ? "core:esign_acknowledgment_request_sent"
                : "core:esign_signature_request_sent"
            )}
          />
          <Text className={"text-secondary"}>
            {t("core:esign_request_sent_notified", { count: recipientCount })}
          </Text>
        </Stack>
      </Stack>
    </Modal>
  );
}
